import { InjectionToken } from '@angular/core';
import { ModalTooltipOptions } from '@shared/v2';

export const SD_MODAL_TOOLTIP_OPTIONS_TOKEN = new InjectionToken<ModalTooltipOptions>('SD_MODAL_TOOLTIP_OPTIONS');
